module.exports = __webpack_public_path__ + "static/media/social1.e3134aea.png";